var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createTheme } from '@mui/material';
import { getIsMobile } from './services/utilisateur';
export var toUpperCaseFirstChar = function (stringValue) {
    return stringValue
        ? stringValue.charAt(0).toUpperCase() + stringValue.slice(1)
        : stringValue;
};
export var FONT_SIZE = {
    SMALL: '11px',
    MEDIUM: '13px',
    LARGE: '15px',
};
var COLOR_PRIMARY = '#3A98B9';
var COLOR_FONT = '#fff';
var COLOR_BLACK = '#777a78';
var COLOR_ERROR = '#DF7861';
export var customColor = {
    header: {
        main: '#425d72',
        light: '#1DA598',
        contrastText: COLOR_FONT,
    },
    collaborateur: {
        main: '#54BAB9',
        light: '#9ED2C6',
        contrastText: COLOR_FONT,
    },
    client: {
        main: '#4b7084',
        light: '#26a69a',
        contrastText: COLOR_FONT,
    },
    affaire: {
        main: '#219C90',
        light: '#A0BCC2',
        contrastText: COLOR_FONT,
    },
    activite: {
        main: '#6daf95',
        light: '#9ED5C5',
        contrastText: COLOR_FONT,
    },
    white: {
        main: COLOR_FONT,
        contrastText: COLOR_PRIMARY,
    },
    neutre: {
        main: COLOR_BLACK,
        light: '#d6d2d2',
        contrastText: COLOR_FONT,
    },
    disabled: {
        main: '#bdb8b8',
        light: '#bdb8b8',
        contrastText: COLOR_FONT,
    },
};
// @ts-ignore
export var theme = createTheme({
    typography: {
        fontFamily: ['Quicksand', 'sans-serif'].join(','),
        fontSize: getIsMobile() ? 9 : 13,
        subtitle1: {
            color: COLOR_FONT,
            backgroundColor: COLOR_PRIMARY,
        },
    },
    palette: __assign({ background: {
            default: '#fff',
            paper: '#fff',
        }, primary: {
            main: COLOR_PRIMARY,
            contrastText: COLOR_FONT,
        }, secondary: {
            main: '#F4B183',
            contrastText: COLOR_FONT,
        }, info: {
            main: '#bdb8b8',
            contrastText: COLOR_FONT,
        }, error: {
            main: COLOR_ERROR,
            contrastText: COLOR_FONT,
        }, warning: {
            main: '#f1c21b',
            contrastText: COLOR_FONT,
        }, success: {
            main: '#26a69a',
            contrastText: COLOR_FONT,
        } }, customColor),
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                listbox: {
                    '& .MuiAutocomplete-option': {
                        fontSize: '0.8rem',
                    },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: '0.8rem',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    color: "".concat(COLOR_PRIMARY, " !important"),
                    fontWeight: 'bold',
                    position: 'absolute',
                    bottom: -14,
                    right: 0,
                    backgroundColor: COLOR_FONT,
                    padding: 0,
                    paddingLeft: 4,
                    whiteSpace: 'nowrap',
                    '&.Mui-error': {
                        color: "".concat(COLOR_ERROR, " !important"),
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    position: 'relative',
                    padding: 10,
                },
            },
        },
        MuiTableSortLabel: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: 'white',
                    },
                    '&.Mui-active': {
                        '&&': {
                            color: 'white',
                            '& * ': {
                                color: 'white',
                            },
                        },
                    },
                },
            },
        },
        MuiStepConnector: {
            styleOverrides: {
                line: {
                    borderTopWidth: 2,
                    borderRadius: 25,
                    margin: 8,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    height: 28,
                },
                label: {
                    paddingLeft: 9,
                    paddingRight: 9,
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paperAnchorRight: {
                    paddingTop: 45,
                    paddingRight: 10,
                    paddingLeft: 10,
                    paddingBottom: 10,
                    height: 'calc(100% - 55px)',
                },
            },
        },
    },
});
//# sourceMappingURL=theme.js.map